import { type Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import {
  MENTOR_LABEL,
  MENTEE_LABEL,
} from 'hb-react/shared/apps/Mentoring/constants';

export const getMentorLabel = (label: string) => label || MENTOR_LABEL;
export const getLowerCaseMentorLabel = (label: string) =>
  label?.toLowerCase() || MENTOR_LABEL.toLowerCase();

export const getMenteeLabel = (label: string) => label || MENTEE_LABEL;
export const getLowerCaseMenteeLabel = (label: string) =>
  label?.toLowerCase() || MENTEE_LABEL.toLowerCase();

export const getProgramTopicId = ({
  parentType,
  parentId,
}: {
  parentId: Program['parent_id'];
  parentType: Program['parent_type'];
}) => (parentType === 'Topics::Topic' ? parentId : undefined);
